import React from 'react';
import { connect, useSelector } from 'react-redux';
import Modal from '@mui/material/Modal';
import { confirmRemoveItemStyles as styles } from './confirmRemoveItem.tailwind';
import { getMyCart, removecartItem } from '../../../../redux/slices/cartSlice';
import Button from '../../Button/Button';
import CloseIcon from '@mui/icons-material/Close';

const ConfirmRemoveItemModal = ({ isOpen, onClose, removeToken, getCart, selectedTokenId }) => {
  const { cartData, removingCartItem } = useSelector((state) => state.cart);
  const { currentSeason } = useSelector(state => state.seasons);
  
  // handle remove item
  const handleRemoveToken = async() => {
    const removeTokenResponse = await removeToken({ tokenId: selectedTokenId, orderId: cartData._id });
    if(removecartItem.fulfilled.match(removeTokenResponse)){
      onClose(); // close modal
      await getCart({
        seasonId: currentSeason?._id
      }); // refresh-cart
    }
  }

  return (
    <Modal
      open={isOpen}
      onClose={() => {}} // Prevent closing when clicking outside
      disableAutoFocus
    >
      <div className={styles.container}>
        <button onClick={onClose} className={styles.closeIcon} disabled={removingCartItem}>
          <CloseIcon sx={{ fontSize: "18px" }} />
        </button>
        <div className={styles.heading}>Remove Cart Token</div>
        <div className={styles.description}>
          <span className={styles.confirmationText}>Are you sure you want to remove this token from your cart?</span>
        </div>
        <div className={styles.buttonContainer}>
          <Button variant="primary" onClick={onClose} className={styles.button} disabled={removingCartItem}>
            Cancel
          </Button>
          <Button variant="lighttheme" className={styles.cancelButton} onClick={handleRemoveToken} disabled={removingCartItem}>
            {removingCartItem ? `Removing...` : `Remove Token`}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    getCart: (data) => dispatch(getMyCart(data)),
    removeToken: (data) => dispatch(removecartItem(data)),
  };
};
export default connect(null, mapDispatchToProps)(ConfirmRemoveItemModal)